




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import CandidatePortalLogo from './../CandidatePortalLogo.vue';
import Avatar from 'vue-avatar';
import { Job } from '@/models/jobs/job';
import LocalJobs from '@/components/Commons/LocalJobs.vue';
import {
  evalHtmlContent,
  LOGING_URL,
  SIGN_UP_URL,
  FIND_JOBS_URL,
  SAVED_JOBS_URL,
  ANON_SAVED_JOBS_URL,
  REFER_A_FRIEND_URL,
  ANON_REFER_A_FRIEND_URL,
  HOME_URL,
  MY_JOBS_URL,
  JOB_ALERTS_URL,
  SURVEY_URL,
  MY_REFERRAL_URL,
  FORUM_URL,
  HELP_URL,
  LOGOUT_URL,
  USER_PROFILE_URL,
} from '../../plugins/HtmlContentInjectionUtils';
declare var window: any;

@Component({
  name: 'DynamicContentComponent',
  components: {
    CandidatePortalLogo,
    LocalJobs,
    Avatar,
  },
})
export default class DynamicContentComponent extends Vue {
  @Prop() content!: string;
  $wlToastr: any;
  public localjobs: Job[] = [];

  get applicationName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME');
  }

  redirectToRoute(routeName) {
    this.$cookies.remove('OAuthRegistrationType');
    this.$cookies.remove('OAuthProvider');
    this.$router.push({ name: routeName });
  }

  get getInjectedContent() {
    const life_at_label = this.$t('menu.top.lifeAtLabel')+'';
    const refer_a_friend_label = this.$t('menu.top.referafriend')+'';
    const browse_jobs_label = this.$t('menu.top.browsejobs')+'';
    const header_login_button_label = this.$t('menu.top.login')+'';
    const header_join_talent_community_label = this.$t('menu.top.joincommunity')+'';
    return evalHtmlContent(
      this.content,
      this.isLoggedIn,
      this.brandingLogo(),
      vxm.users.myUserProfile,
      this.termsOfServiceURL,
      this.privacyPolicyURL,
      vxm.configs.getGlobalConfigValue('COMPANY_NAME'),
      life_at_label,
      refer_a_friend_label,
      browse_jobs_label,
      header_login_button_label,
      header_join_talent_community_label,
    );
  }

  logout() {
    vxm.users.logout();
    this.$router.push('/');
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get showReferFriendPopup() {
    return vxm.configs.getGlobalConfigValue('INTERNAL_REFERRAL_ENABLED');
  }
  
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }

  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }

  brandingLogo(): string {
    let bLogo: any;
    if (sessionStorage) {
      bLogo = sessionStorage.getItem('brandingLogo');
      // console.log('Using session storage', bLogo);
    } else {
      if (Vue.cookies.get('brandingLogo')) {
        bLogo = Vue.cookies.get('brandingLogo');
        // console.log('Using cookies', bLogo);
      } else {
        bLogo = '../assets/images2/workLLama-logo.svg';
        // console.log('Neither cookies nor session storage are available', bLogo);
      }
    }
    return bLogo;
  }

  updated() {
    this.setupView();
  }

  async mounted() {
    this.setupView();
  }

  get cmsHeader() {
    return vxm.utility.cmsHeaderData;
  }

  get displayHeaderFromCMS() {
    return vxm.configs.getGlobalConfigValue('DISPLAY_HEADER_FROM_CMS')
  }


  setupView() {
    let vm = this;
    this.addOnClickEvent(`[wl-route="${ANON_REFER_A_FRIEND_URL}"]`, (e) => {
      if (vm.showReferFriendPopup) vm.showReferAFriendPopupAnon();
      else vm.$router.push('/anonreferafriend');
      e.preventDefault();
    });

    this.addOnClickEvent(`[wl-route="${REFER_A_FRIEND_URL}"]`, (e) => {
      if (vm.showReferFriendPopup) vm.showReferAFriendPopup();
      else vm.$router.push('/referafriend');
      e.preventDefault();
    });

    this.addOnClickEvent(`[wl-route="${SIGN_UP_URL}"]`, (e) => {
      vm.redirectToRoute('Signup');
    });

    this.addOnClickEvent(`[wl-route="${LOGOUT_URL}"]`, this.logout);

    this.addOnClickEvent(`[wl-route="${ANON_SAVED_JOBS_URL}"]`, this.openAnonSavedJobs);

    this.addOnClickRoutingEvent(LOGING_URL, '/login');
    this.addOnClickRoutingEvent(FIND_JOBS_URL, '/findjobs');
    this.addOnClickRoutingEvent(SAVED_JOBS_URL, '/savedjobs');

    this.addOnClickRoutingEvent(HOME_URL, '/home');
    this.addOnClickRoutingEvent(MY_JOBS_URL, '/myjobstatus');
    this.addOnClickRoutingEvent(JOB_ALERTS_URL, '/jobAlert');
    this.addOnClickRoutingEvent(SURVEY_URL, '/survey');
    this.addOnClickRoutingEvent(MY_REFERRAL_URL, '/myreferralslist');
    this.addOnClickRoutingEvent(FORUM_URL, '/forum');
    this.addOnClickRoutingEvent(HELP_URL, '/help');
    this.addOnClickRoutingEvent(USER_PROFILE_URL, '/myprofile/v2/details');

    // Remove false / not commited conditions
    document.querySelectorAll('[wl-if=false]').forEach((e) => e.remove());

    this.highlightSelectedMenu(this.$route.path);
  }

  addOnClickEvent(selector: string, action) {
    window.$(document).off('click', selector, action);
    window.$(document).on('click', selector, action);
  }

  addOnClickRoutingEvent(url: string, route: string) {
    const vm = this;
    const element = document.querySelectorAll(`[wl-route="${url}"]`);
    element.forEach((link) => {
      link.addEventListener('click', (e) => {
        vm.$router.push(route);
      });
    });
  }

  showReferAFriendPopup() {
    this.$modal.show('refer-friend-popup');
  }

  showReferAFriendPopupAnon() {
    this.$modal.show('refer-friend-popup-anon');
  }

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(newVal) {
    //this.setupView();
    this.highlightSelectedMenu(this.$route.path);
  }

  // Control highlighted menú
  highlightSelectedMenu(path: string) {
    const pathName = window.location.pathname;
    const elements = document.querySelectorAll(`[active-route="${path}"]`)
      .length
      ? document.querySelectorAll(`[active-route="${path}"]`)
      : document.querySelectorAll(`[active-route="${pathName}"]`);
    elements.forEach((item) => {
      let activeClass = item.getAttribute('active-class') || '';
      if (activeClass) {
        const siblings = document.querySelectorAll(
          `[active-class="${activeClass}"]`,
        );
        siblings.forEach((sibling) => {
          sibling.className = sibling.className.replace(activeClass, '');
        });
        item.className =
          item.className.replace(activeClass, '') + ' ' + activeClass;
      }
    });
  }

  
  openAnonSavedJobs() {
    const vm = this;
    if (this.localJobCount == 0) {
      vm.$wlToastr('success', 'There are no saved jobs', vm.$t('savedJobs.text'));
    } else {
      this.$modal.show('localjobsmodal');
    }
  }

  get localJobCount() {
    let res = 0;
    let jobs = vxm.utility.localjobs;
    var utilJobscnt = jobs.length;
    if (localStorage.getItem('localjobs')) {
      this.localjobs = JSON.parse(localStorage.getItem('localjobs') || '[]');
    }
    if (utilJobscnt >= this.localjobs.length) res = utilJobscnt;
    else res = this.localjobs.length;
    return res;
  }

  destroyed() {
    this.$modal.hide('refer-friend-popup-anon');
  }
}
